
import { Button } from "@/components/ui/button";

import { useDisconnect } from 'wagmi';
import { web3Modal } from '../Web3Provider';
import { toast } from "sonner";

interface TokenCheckStepProps {
  isCheckingToken: boolean;
  hasToken: boolean;
  onProceedAnyway: () => void;
  onRecheckWallet: () => void;
  onTakeCipher: () => void;
  onDisconnect: () => void;
  pancakeswapUrl: string;
}

const TokenCheckStep = ({
  isCheckingToken,
  hasToken,
  onProceedAnyway,
  onRecheckWallet,
  onTakeCipher,
  onDisconnect,
  pancakeswapUrl,
}: TokenCheckStepProps) => {
  const { disconnect } = useDisconnect();

  const handleDisconnect = () => {
    try {
      // Properly disconnect using wagmi
      disconnect();
      
      // Close the web3modal if it's open
      web3Modal.close();
      
      // Clear only minimal wallet-related storage to avoid issues with reconnection
      const criticalWalletKeys = [
        'wagmi.connected', 
        'wagmi.wallet'
      ];
      
      criticalWalletKeys.forEach(key => {
        localStorage.removeItem(key);
      });
      
      // Call the parent component's disconnect handler
      onDisconnect();
      
      toast.success("Wallet disconnected successfully");
    } catch (error) {
      console.error("Error disconnecting wallet:", error);
      toast.error("There was an issue disconnecting your wallet");
      
      // Force a page reload as last resort
      window.location.reload();
    }
  };

  return (
    <div className="text-center space-y-6">
      {/* Airdrop Eligibility Banner */}
      <div className="mb-6 p-4 bg-tan text-navy-dark rounded-lg">
        <div className="flex items-center justify-center space-x-2 mb-2">
          <img 
            src="/lovable-uploads/clr_4.png" 
            alt="Bromentum Logo" 
            className="w-6 h-6 object-contain"
          />
          <span className="font-bold">🎁 Airdrop Eligibility</span>
        </div>
        <p className="text-sm font-bold">Any BroCode = Airdrop Eligible</p>
        <p className="text-xs mt-1">Higher BroScore = Better airdrop allocation</p>
      </div>

      <h2 className="text-2xl font-patrick text-tan">Step 2: Token Check</h2>
      
      {isCheckingToken ? (
        <div className="space-y-4">
          <p className="text-lg text-tan">Checking your wallet for $TOP1 tokens...</p>
          <div className="flex justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-tan"></div>
          </div>
        </div>
      ) : (
        <>
          {hasToken ? (
            <div className="space-y-4">
              <div className="flex items-center justify-center space-x-2">
                <img 
                  src="/lovable-uploads/clr_4.png" 
                  alt="Bromentum Logo" 
                  className="w-8 h-8 object-contain"
                />
                <p className="text-xl font-bold text-foreground">$TOP1 tokens detected!</p>
              </div>
              <p className="text-lg text-tan">You're ready to earn your BroCode and join the brotherhood!</p>
              
              <div className="bg-navy-dark p-4 rounded-lg border border-tan-dark">
                <p className="text-sm text-tan mb-2">💡 <strong>Choose your path:</strong></p>
                <p className="text-sm text-tan">• Take the Cipher (quick quiz)</p>
                <p className="text-sm text-tan">• Add liquidity (support the ecosystem)</p>
              </div>
              
              <Button 
                onClick={onTakeCipher}
                className="bg-tan text-navy hover:bg-tan-dark px-8 py-6 text-xl mt-4"
              >
                Choose Your Path
              </Button>
            </div>
          ) : (
            <div className="space-y-6">
              <h2 className="text-3xl font-bold text-tan">💀 Bro WTF you doin here?</h2>
              <p className="text-xl text-tan">You don't even hold $TOP1.<br />That's like showing up to the gym without a pump.</p>
              
              <div className="bg-navy-dark p-4 rounded-lg border border-tan-dark">
                <p className="text-sm text-tan mb-2">💡 <strong>Good news:</strong></p>
                <p className="text-sm text-tan">Even Shadow Bros get airdrop eligibility!</p>
                <p className="text-sm text-tan">Your airdrop allocation depends on BroScore earned.</p>
              </div>
              
              <div className="mt-8 space-y-6">
                <a 
                  href={pancakeswapUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block bg-tan text-navy-dark font-bold text-xl px-8 py-3 rounded-lg hover:bg-tan-dark transition-colors"
                >
                  BUY THE TOKEN
                </a>
                
                <p className="text-lg text-tan">You can still earn your BroCode. Choose your path below.</p>
                
                <div className="flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-4">
                  <Button 
                    onClick={onProceedAnyway}
                    className="bg-navy-dark text-tan border border-tan-dark hover:bg-navy"
                  >
                    ✅ Choose Path (Shadow Bro Rank)
                  </Button>
                  
                  <Button 
                    onClick={onRecheckWallet}
                    className="bg-tan text-navy-dark hover:bg-tan-dark"
                    disabled={isCheckingToken}
                  >
                    🚀 I Bought It – Recheck Wallet
                  </Button>
                </div>
              </div>
            </div>
          )}
        </>
      )}
      
      <div className="mt-6 border-t border-tan-dark pt-4">
        <Button 
          onClick={handleDisconnect}
          variant="outline"
          className="text-tan hover:text-tan-dark"
        >
          Disconnect Wallet
        </Button>
      </div>
    </div>
  );
};

export default TokenCheckStep;
